(function() {

  /******************************
   * Helper: cm-Werte parsen
   ******************************/
  function parseNumberFromCm(str) {
    return parseFloat(String(str || "").replace("cm", "").replace(",", ".").trim());
  }

  /******************************
   * Helper: m²-Wert us Option parsen
   * (nimmt opt.value ODER opt.textContent)
   ******************************/
  function parseAreaFromOption(opt) {
    const raw = (opt && (opt.value || opt.textContent)) ? (opt.value || opt.textContent) : "";
    // erlaubt: "0.03 m²", "0,03 m2", "0.03", etc.
    const cleaned = String(raw)
      .replace(/\s/g, "")
      .replace("m²", "")
      .replace("m2", "")
      .replace("m^2", "")
      .replace(",", ".");
    const num = parseFloat(cleaned);
    return isNaN(num) ? null : num; // in m²
  }

  function getTargetSize() {
    const wInput = document.getElementById("target-width-cm");
    const hInput = document.getElementById("target-height-cm");
    if (!wInput || !hInput) return null;

    const w = parseNumberFromCm(wInput.value);
    const h = parseNumberFromCm(hInput.value);

    if (isNaN(w) || isNaN(h) || w <= 0 || h <= 0) return null;
    return { width: w, height: h }; // in cm
  }

  /******************************
   * Beste Variante wählen (m²)
   ******************************/
  function selectBestVariant() {
    const select = document.querySelector(
      '.product-variant-container[data-js-product-variant-container="select"]'
    );
    if (!select) return;

    const target = getTargetSize();
    if (!target) return;

    // cm² -> m²  (1 m² = 10'000 cm²)
    const requiredAreaM2 = (target.width * target.height) / 10000;

    const options = Array.from(select.options || []);
    if (!options.length) return;

    let bestFit = null;
    let bestFitArea = null;

    let closest = null;
    let closestDiff = null;

    options.forEach(opt => {
      const areaM2 = parseAreaFromOption(opt);
      if (areaM2 == null) return;

      // 1) Best Fit: kleinsti Variante, wo gross gnueg isch
      if (areaM2 >= requiredAreaM2) {
        if (bestFit == null || areaM2 < bestFitArea) {
          bestFit = opt;
          bestFitArea = areaM2;
        }
      }

      // 2) Fallback: nächsti Fläche
      const diff = Math.abs(areaM2 - requiredAreaM2);
      if (closest == null || diff < closestDiff) {
        closest = opt;
        closestDiff = diff;
      }
    });

    const chosen = bestFit || closest;
    if (!chosen) return;

    if (select.value !== chosen.value) {
      select.value = chosen.value;
      select.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  /******************************
   * Input-Änderige überwache
   ******************************/
  function setupWatchers() {
    const wInput = document.getElementById("target-width-cm");
    const hInput = document.getElementById("target-height-cm");
    if (!wInput || !hInput) return;

    let lastW = wInput.value;
    let lastH = hInput.value;

    ["input", "change", "blur"].forEach(evt => {
      wInput.addEventListener(evt, selectBestVariant);
      hInput.addEventListener(evt, selectBestVariant);
    });

    setInterval(function() {
      const curW = wInput.value;
      const curH = hInput.value;

      if (curW !== lastW || curH !== lastH) {
        lastW = curW;
        lastH = curH;
        selectBestVariant();
      }
    }, 200);
  }

  function init() {
    setupWatchers();
    selectBestVariant();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

})();
